<h1 mat-dialog-title>
  {{ title | translate}}
</h1>

<div mat-dialog-content class="mb-20">
  <p>{{ message | translate}}</p>
</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="onDismiss()">
    <span class="mx-8">
      {{'DIALOGS.ACTIONS.CANCEL' | translate}}
    </span>
  </button>
  <div class="btn-accept p-0 m-0">
    <button mat-raised-button color="accent" class="ml-8" (click)="onConfirm()">
      <span class="mx-8">
        {{'DIALOGS.ACTIONS.ACCEPT' | translate}}
      </span>
    </button>
  </div>
</div>
